export const hardCodedDatavanterUsers = ['expansion_prod_user', 'dev_user', 'uat_user', 'test_user'];

export const SUPPORT_EMAIL = 'requestmanager@datavant.com';
export const SUPPORT_PHONE = '888-449-3250';

export const RM_BASIC_SUPPORT_EMAIL = 'chartreview@datavant.com';
export const RM_BASIC_SUPPORT_PHONE = '877-445-9293';

export const UUID_DATAVANT = 'uuid-datavant';

export const SUPPORT_SLACK_AOD_CONNECTIONS = 'https://datavant.enterprise.slack.com/archives/C07CBEFAQF6';
export const SUPPORT_SLACK_DIGITAL_WORKFLOWS = 'https://datavant.enterprise.slack.com/archives/C06D56ZMNBC';
export const SUPPORT_SLACK_STRAT_CONNECTIONS = 'https://datavant.enterprise.slack.com/archives/C070F7FNQAZ';
